module.exports = __webpack_public_path__ + "img/blank-policy.82fe8a96.png";